import Link from 'next/link';
import { ElementType, FC } from 'react';
import { useTranslation } from 'utils/i18n';

interface Props {
  name: string;
  image: string;
  location: string;
  distance: number;
  url: string;
  component?: ElementType;
}

const VenueCard: FC<Props> = ({
  name,
  image,
  location,
  distance,
  url,
  component: Component = 'div',
}) => {
  const { t } = useTranslation('common');

  return (
    <Component className="venue-card">
      <Link href={url}>
        <img src={image} alt={name} className="venue-card__image" />
      </Link>
      <h4 className="venue-card__name">
        <Link href={url}>{name}</Link>
      </h4>
      <p className="venue-card__location">{location}</p>
      <p className="venue-card__distance">
        <i className="fas fa-map-marker-alt" />
        {t('miles', { count: distance })}
      </p>
    </Component>
  );
};

export default VenueCard;
